<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { useConfirm } from 'primevue/useconfirm'
import { useToast } from 'primevue/usetoast'
import BottomStackItem from '@dashboard/components/common/BottomStackItem.vue'
import MaintenanceOverlay from '@dashboard/components/common/MaintenanceOverlay.vue'
import NewVersionBanner from '@dashboard/components/common/NewVersionBanner.vue'
import NotificationCard from '@dashboard/components/common/NotificationCard.vue'
import NotificationStack from '@dashboard/components/common/NotificationStack.vue'
import { authReconnecting } from '@dashboard/router/middleware/authRecovery'
import DefaultLayout from '@dashboard/components/layouts/DefaultLayout.vue'
import { usePostHog } from '@dashboard/composables/usePosthog'
import { useThemePreference } from '@dashboard/composables/useThemePreference'
import { ArrowPathIcon } from '@heroicons/vue/24/outline'
import ConfirmDialog from 'primevue/confirmdialog'
import { provide } from 'vue'

usePostHog()

useThemePreference()
const toast = useToast()
const confirm = useConfirm()
provide('confirm', confirm)
provide('toast', toast)
</script>

<template>
  <div>
    <ConfirmDialog />
    <MaintenanceOverlay />
    <NotificationStack />
    <NewVersionBanner />
    <BottomStackItem layer="notifications">
      <NotificationCard v-if="authReconnecting" message="Reconnecting…" :dismissible="false">
        <template #icon>
          <ArrowPathIcon class="size-[18px] animate-spin text-sky-300 motion-reduce:animate-none" aria-hidden="true" />
        </template>
      </NotificationCard>
    </BottomStackItem>
    <DefaultLayout />
    <VueQueryDevtools v-if="false" />
  </div>
</template>
